import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "menugenius-logo-tint";

const apply = (enabled) => {
  const root = document.documentElement;
  if (enabled) {
    root.setAttribute("data-logo-tint", "on");
  } else {
    root.removeAttribute("data-logo-tint");
  }
};

const read = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "on";
  } catch { return false; }
};

/**
 * Initialise on app boot to avoid flash. Call from index.js before render.
 */
export function initLogoTint() {
  apply(read());
}

/**
 * Hook to read/toggle the "Resaltar logo con color de tema" preference.
 * Frontend-only (per-browser); not synced to backend yet.
 */
export function useLogoTint() {
  const [enabled, setEnabled] = useState(read);

  useEffect(() => {
    apply(enabled);
  }, [enabled]);

  // Cross-tab sync
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) setEnabled(e.newValue === "on");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggle = useCallback((next) => {
    const v = typeof next === "boolean" ? next : !enabled;
    try { window.localStorage.setItem(STORAGE_KEY, v ? "on" : "off"); } catch { /* ignore */ }
    setEnabled(v);
  }, [enabled]);

  return [enabled, toggle];
}

export default useLogoTint;
